import { applyMiddleware, legacy_createStore as createStore } from 'redux';
import { persistStore } from 'redux-persist';
import thunk from 'redux-thunk';
import reducer from './reducers';

const store = createStore(reducer, applyMiddleware(thunk));
const persistor = persistStore(store);

export { persistor, store };
